import { render, staticRenderFns } from "./LevelAvatarBadge.vue?vue&type=template&id=18aced31&scoped=true"
import script from "./LevelAvatarBadge.vue?vue&type=script&lang=js"
export * from "./LevelAvatarBadge.vue?vue&type=script&lang=js"
import style0 from "./LevelAvatarBadge.vue?vue&type=style&index=0&id=18aced31&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18aced31",
  null
  
)

export default component.exports